import parse from "html-react-parser";
import Modal from "../../component/Modal";
import useQuestionOfDay from "./useQuestionOfDay";
import celebrate from "../../assets/newCeleb.gif";

const QuestionOfDay = ({ open, onClose }) => {
  const { state, handleOptionSelect, submitAnswer } = useQuestionOfDay();
  return (
    <Modal isOpen={open} title="Question of the day!" onClose={onClose}>
      <br />
      <div>
        <h2 className="text-lg font-semibold mb-4">
          {parse(state?.question || "")}
        </h2>
        <ul className="space-y-2">
          {state.options?.map((option) => (
            <li
              key={option.id}
              className={`flex items-center px-4 py-2 rounded-lg cursor-pointer ${
                state.correctAns && state.correctAns === option.id
                  ? "bg-green-100"
                  : state.correctAns && state.selectedOption === option.id
                  ? "bg-red-100"
                  : "bg-white"
              } hover:bg-gray-100`}
            >
              <input
                type="radio"
                id={`option${option.id}`}
                name="options"
                className="mr-2 cursor-pointer"
                onChange={() => handleOptionSelect(option.id)}
              />
              <label htmlFor={`option${option.id}`} className="cursor-pointer">
                {option.id})&nbsp; {parse(option.text || "")}
              </label>
            </li>
          ))}
        </ul>
        <div className="flex item-center justify-center mt-5">
          <button
            onClick={submitAnswer}
            className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded"
          >
            Submit
          </button>
        </div>
      </div>
      {state.isCelebrate && (
        <img
          src={celebrate}
          alt="celebrate"
          className="absolute inset-0 flex items-center justify-center z-20 w-[calc(100%/1.2)] mt-50"
        />
      )}
    </Modal>
  );
};

export default QuestionOfDay;
